import { handleClick} from './lib/handlers.js';
import { verseButton, emailInput, emailError } from './lib/elements.js';

emailInput.addEventListener('keydown', () => {
    emailInput.classList.remove('error');
    emailError.style.visibility= "hidden";
});
verseButton.addEventListener('click', handleClick);